module.exports = __webpack_public_path__ + "img/permice-min.e56d7d68.png";